module.exports = __webpack_public_path__ + "media/empty-states/referrals-8a3bd278.png";